import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import common from "../../common.module.scss";
import style from "../OrderHistory.module.scss";
import styles from "./OrderHistoryMobile.module.scss";
import { numberToFinanceFormat } from "../../../../../utils";
import { CURRENCIES, ORDER_STATUSES_DATA } from "../../../../../mock";
import BallIcon from "../../../../shared/icons/BallIcon";
import LogoIcon from "../../../../shared/icons/LogoIcon";
import LupeIcon from "../../../../shared/icons/LupeIcon";
import UsersIcon from "../../../../shared/icons/UsersIcon";
import OrdersIcon from "../../../../shared/icons/OrdersIcon";
import UncheckCircleIcon from "../../../../shared/icons/UncheckCircleIcon";
import OrdersInfoDirections from "../OrdersInfoDirections";
import ListFilesOrder from "../ListFilesOrder";
import AviaOrdersIcon from "../../../../shared/icons/transport-type/AviaOrdersIcon";
import OrdersInfoCargo from "../OrdersInfoCargo";
import ArrowBackIcon from "../../../../shared/icons/ArrowBackIcon";
import ArrowDownIconNew from "../../../../shared/icons/ArrowDownIconNew";
import ArrowUpIcon from "../../../../shared/icons/ArrowUpIcon";
import AccessDeniedModal from "../../../../shared/SubscriptionModal/AccessDeniedModal";
import { useSelector } from "react-redux";

const OrderHistoryMobile = ({
  item,
  onClose,
  statusHistory,
  recipientName,
  senderName,
  cargoDetails,
  cityFrom,
  cityTo,
  routeData,
  isLoadingMap,
  routeStartCity,
  coordinateTruck,
  bookingDate,
  driverPhotos,
  listDocDriver,
  listFilesOrder,
  refreshDocuments,
}) => {
  const { t } = useTranslation();

  const [isChatOpen, setIsChatOpen] = useState(false);
  const { user } = useSelector((state) => state);
  const [isDisplayModal, changeDisplayModal] = useState(false);

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}.${month}.${year} - ${hours}:${minutes}:${seconds}`;
  };

  const getIconColor = (status, step) => {
    const rejectedStatuses = [
      "expeditorrejected",
      "canceled",
      "rejectedloadingcargomoderation",
      "rejectedunloadingcargomoderation",
    ];
    const currentStep = {
      moderation: 1,
      awaitingpayment: 1,
      expeditorrejected: 1,
      // canceled: 1,
      published: 2,
      booked: 3,
      confirmed: 3,
      processloadingcargo: 3,
      loadingcargomoderation: 3,
      waitstarttrip: 3,
      rejectedloadingcargomoderation: 3,
      onthetrip: 4,
      processunloadingcargo: 4,
      unloadingcargomoderation: 4,
      rejectedunloadingcargomoderation: 4,
      completed: 5,
    };

    if (rejectedStatuses.includes(status) && step === currentStep[status]) {
      return { backgroundColor: "#C84620", iconColor: "#FFF", IconType: 2 };
    } else if (step <= currentStep[status]) {
      return { backgroundColor: "#212121", iconColor: "#FFF", IconType: 2 };
    } else {
      return { backgroundColor: "#F0F0F0", iconColor: "#212121", IconType: 1 };
    }
  };

  const renderIcon = (step) => {
    const status = String(item?.status || "").toLowerCase();
    const { backgroundColor, iconColor, IconType } = getIconColor(status, step);

    switch (step) {
      case 1:
        return (
          <>
            <div className={style.history_icons_circle} style={{ backgroundColor }}>
              <div className={style.history_icons_icon}>
                <LogoIcon type={IconType} color={iconColor} width="32px" height="32px" />
              </div>
            </div>
          </>
        );
      case 2:
        return (
          <>
            <div className={style.history_icons_line} style={{ backgroundColor }}></div>
            <div className={style.history_icons_circle} style={{ backgroundColor }}>
              <div className={style.history_icons_icon}>
                <LupeIcon color={iconColor} />
              </div>
            </div>
          </>
        );
      case 3:
        return (
          <>
            <div className={style.history_icons_line} style={{ backgroundColor }}></div>
            <div className={style.history_icons_circle} style={{ backgroundColor }}>
              <div className={style.history_icons_icon}>
                <UsersIcon color={iconColor} />
              </div>
            </div>
          </>
        );
      case 4:
        return (
          <>
            <div className={style.history_icons_line} style={{ backgroundColor }}></div>
            <div className={style.history_icons_circle} style={{ backgroundColor }}>
              <div className={style.history_icons_icon}>
                <AviaOrdersIcon color={iconColor} />
              </div>
            </div>
          </>
        );
      case 5:
        return (
          <>
            <div className={style.history_icons_line} style={{ backgroundColor }}></div>
            <div className={style.history_icons_circle} style={{ backgroundColor }}>
              <div className={style.history_icons_icon}>
                <UncheckCircleIcon color={iconColor} />
              </div>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  const setSummary = (status) => {
    // Reusing keys from orderInfo.orderHistory
    switch (status) {
      case "moderation":
        return t("orderInfo.orderHistory.summaryModeration");
      case "published":
        return "";
      case "waitstarttrip":
        return "";
      case "awaitingpayment":
        return "";
      case "waitingforcompletion":
        return "";
      case "inprocess":
        return "";
      case "onthetrip":
        return t("orderInfo.orderHistory.summaryOnTheTrip");
      case "waitloadingcargo":
        return t("orderInfo.orderHistory.summaryWaitLoading");
      case "completed":
        return "";
      case "rejectedunloadingcargomoderation":
        return "";
      case "unloadingcargomoderation":
        return "";
      case "processunloadingcargo":
        return t("orderInfo.orderHistory.summaryProcessUnloading");
      case "processloadingcargo":
        return t("orderInfo.orderHistory.summaryProcessLoading"); // Corrected typo
      case "unloadingcargo":
        return "";
      case "loadingcargo":
        return t("orderInfo.orderHistory.summaryLoadingCargo");
      case "waitcompletion":
        return "";
      case "canceled":
        return "";
      case "booked":
        return `${item?.driverSurname} ${item?.driverName}`;
      case "expeditorrejected":
        return;
      case "confirmed":
        return;

      default:
        return "";
    }
  };

  return (
    <div className={cn("modal-overlay", styles.mobile__wrapper)}>
      <div className={styles.mobile__modal}>
        <div className={styles.topbar}>
          <ArrowBackIcon style={{ cursor: "pointer" }} fill="#6D7885" onClick={onClose} />

          <div className={styles.topbar__content}>
            <div className={style.history_title}>{t("orderInfo.orderHistory.title")}</div>
            <div
              className={style.history_status_title}
              style={{ color: ORDER_STATUSES_DATA(t)[item?.status]?.color }}
            >
              <BallIcon fill={ORDER_STATUSES_DATA(t)[item?.status]?.color} />
              {ORDER_STATUSES_DATA(t)[item?.status]?.title || item?.status}
            </div>
          </div>
        </div>
        <div className={styles.mobile__main}>
          <div className={style.history_content}>
            <div className={styles.mobile__icons}>
              {renderIcon(1)}
              {renderIcon(2)}
              {renderIcon(3)}
              {renderIcon(4)}
              {renderIcon(5)}
            </div>

            {isDisplayModal && !(user && user.permissions?.includes("chat_access")) && (
              <AccessDeniedModal onClose={() => changeDisplayModal(false)} />
            )}

            <div className={style.history_details}>
            <div className={style.history_details_line}>
                <BallIcon fill="#6D7885" />
                <div className={style.history_details_border}></div>
                <BallIcon fill="#6D7885" />
              </div>
              <div className={style.history_details_info}>
                {statusHistory &&
                  statusHistory.map((status, index) => (
                    <div key={index} className={style.history_details_item}>
                      <div className={style.history_details_title}>
                        {t(`mockData.orderStatuses.${status.statusCode?.toLowerCase()}`) || status.statusName || status.statusCode}
                      </div>
                      <div className={style.history_details_summary}>
                        {formatDate(status.createdAt)}
                        {status?.author && <span> — {status.author}</span>}
                        {status?.addressName && <span> — {status?.addressName}</span>}
                      </div>
                    </div>
                  ))}
              </div>
            </div>

            {listFilesOrder && listFilesOrder.filter((doc) => doc.documentType === 6).length > 0 ? (
              <>
                <div>{t("orderInfo.orderDecisionAviation.mainDocsTitle")}</div>
                <ListFilesOrder
                  documents={listFilesOrder.filter((doc) => doc.documentType === 6)}
                  refreshDocuments={refreshDocuments}
                  orderStatus={item?.status}
                />
              </>
            ) : null}

            {listFilesOrder && listFilesOrder.filter((doc) => doc.documentType === 7).length > 0 ? (
              <>
                <div>{t("orderInfo.uploadFile.uploadAdditionalDocsTitle")}</div>
                <ListFilesOrder
                  documents={listFilesOrder.filter((doc) => doc.documentType === 7)}
                  refreshDocuments={refreshDocuments}
                  orderStatus={item?.status}
                />
              </>
            ) : null}

            {item && (
              <OrdersInfoDirections
                item={item}
                senderName={item?.senderName}
                recipientName={item?.recipientName}
              />
            )}

            <div className={cn(common.basic_wrapper, styles.mobile__basic)}>
              <div className={common.basic_numbers}>
                <span className={common.basic_price}>
                  {numberToFinanceFormat(item?.price)} {CURRENCIES[item?.currency || "EUR"]?.symbol || ""}
                </span>
                <div className={common.basic_lower_part}>
                  <span className={common.basic_number}> №{item?.number}</span>
                  {item?.referenceNumber && <span className={common.basic_number}>- {item?.referenceNumber}</span>}
                </div>
              </div>
            </div>

            <OrdersInfoCargo item={cargoDetails} getOrder={item} />
          </div>
        </div>
      </div>
      <button className={style.history_btn}></button>
    </div>
  );
};

export default OrderHistoryMobile;
